import React, {useState, useEffect} from "react"
import { Box, Checkbox, List, ListItem, Tab, TabList, TabPanel, Tabs } from "@mui/joy"
import JSONPretty from "react-json-pretty"
import { useDataProvider } from "src/mtska-frontend-data-provider"

const WidgetGeofenceRoles = props => {
    const { doAction, saving } = useDataProvider(props.dataProviderName);
    
    const [geofenceRoles, setGeofenceRoles] = useState([]);
    const roles = (props?.item?.person?.user?.roles ?? []);

    useEffect(() => {
        setGeofenceRoles(props?.item?.geofenceRoles || []);
    }, [props?.item?.geofenceRoles]);

    const handleSelect = (roleId, cityValue) => {
        const updatedGeofenceRoles = [...geofenceRoles];
        const roleIndex = updatedGeofenceRoles.findIndex(gr => gr.role_id === roleId);
        
        if (roleIndex === -1) {
            // Crea nuovo ruolo
            updatedGeofenceRoles.push({
                role_id: roleId,
                cities: [cityValue],
                employment_id: props?.item?._id ?? props?.item?.employment_id
            });
        } else {
            const cityIndex = updatedGeofenceRoles[roleIndex].cities.indexOf(cityValue);
            if (cityIndex === -1) {
                // Aggiungi città
                updatedGeofenceRoles[roleIndex].cities.push(cityValue);
            } else {
                // Rimuovi città
                updatedGeofenceRoles[roleIndex].cities.splice(cityIndex, 1);
            }
        }
        
        setGeofenceRoles(updatedGeofenceRoles);
        
        console.info('lancio action ', {
            action: 'handleGeofenceRoles',
            model: props.dataProviderName,
            data: {
                geofenceRoles: updatedGeofenceRoles
            }
        });

        doAction({
            action: 'handleGeofenceRoles',
            model: props.dataProviderName,
            data: {
                geofenceRoles: updatedGeofenceRoles
            }
        });
    };

    const isSelected = (roleId, cityValue) => {
        const roleData = geofenceRoles.find(gr => gr.role_id === roleId);
        return roleData ? roleData.cities.includes(cityValue) : false;
    };

    const generateOptions = (roleId) => {
        return props.options.map((option, k) => (
            <ListItem key={k}>
                <Checkbox
                    key={k}
                    value={option.value}
                    label={option.label}
                    checked={isSelected(roleId, option.value)}
                    onChange={() => handleSelect(roleId, option.value)}
                    type="checkbox"
                    variant="outlined"
                    autoComplete="off"
                    loading={saving}
                />
            </ListItem>
        ));
    };

    return (
        <Box className={"form-element form-geofence-roles " + props.className}>
            <Tabs defaultValue={0}>
                <TabList>
                    {roles.map((role, index) => (
                        <Tab key={role._id} value={index}>
                            {role.name}
                        </Tab>
                    ))}
                </TabList>
                {roles.map((role, index) => (
                    <TabPanel key={role._id} value={index}>
                        {/* <JSONPretty data={{ id: role._id, name: role.name }} className="json-wrapper" />
                        <JSONPretty data={props?.item?.geofenceRoles.find((gfr) => gfr.role_id === role._id)} className="json-wrapper" /> */}
                        {/* <JSONPretty data={saving} className="json-wrapper" /> */}

                        <List>
                            {generateOptions(role._id)}
                        </List>
                    </TabPanel>
                ))}
            </Tabs>
        </Box>
    )
}

export default WidgetGeofenceRoles